<section class="transactions-table">
   <ul>
      <ng-content select="[body]"></ng-content>
   </ul>
</section>
